export default "__VITE_ASSET__BlN1wj32__"